import React from "react";

const PageLoader = () => (
<div className="loader">
  <div className="justify-content-center jimu-primary-loading"></div>
</div>
);

export default PageLoader;
